{
  "settings": "Nustatymai",
  "yourDigitalAssistant": "Jūsų skaitmeninis padėjėjas",
  "getStarted": "Pradėti",
  "login": "Prisijungti",
  "loggingIn": "Prisijungiama ...",
  "darkMode": "Tamsus režimas",
  "clearHistory": "Išvalyti istoriją",
  "historyCleared": "Istorija išvalyta",
  "changeLanguage": "Kalba",
  "termsAndConditions": "Naudojimo sąlygos",
  "messagePlaceholder": "Rašykite savo žinutę čia ...",
  "messagePlaceholderDisabled": "Rašymas išjungtas ...",
  "feedbackTitle": "Įvertink savo patirtį",
  "feedbackPlaceholder": "Papasakok apie tai (neprivaloma)",
  "feedbackSend": "Siųsti",
  "feedbackClose": "Uždaryti",
  "sessionExpired": "Jūsų sesija baigėsi dėl neveikimo.",
  "startNewSession": "Pradėkite naują sesiją",
  "apiError": "Oi! Kažkas ne taip. Mes stengiamės kuo greičiau tai išspręsti.",
  "apiErrorOffline": "Jūs nesate prisijungę prie interneto.",
  "tryAgain": "Bandyk iš naujo",
  "startOver": "Pradėti iš naujo",
  "chatEnded": "Pokalbiai baigėsi.",
  "chatEndedThankYou": "Ačiū, kad kalbėjotės su mumis!",
  "closeChat": "Uždaryti",
  "startNewChat": "Vėl kalbėk",
  "humanTakeoverStarted": "Dabar esate perkeltas į klientų aptarnavimą ...",
  "humanTakeoverQueued": "Laukia prisijungimo prie agento",
  "humanTakeoverAnAgent": "Agentas",
  "humanTakeoverAgentEntered": "įstojo į pokalbį",
  "humanTakeoverAgentLogout": "paliko pokalbį",
  "humanTakeoverTransfer": "Jus perkelia į naują agentą",
  "humanTakeoverEnded": "Dabar kalbate su savo skaitmeniniu asistentu",
  "version": "Versija",
  "formIntroText": "Norėdami pradėti kalbėtis su mumis, užpildykite šią formą.",
  "formFirstName": "Pirmas vardas",
  "formLastName": "Pavardė",
  "formName": "vardas",
  "formEmail": "Elektroniniu paštu",
  "formWrongEmail": "Nurodykite galiojantį el. Pašto adresą.",
  "formPhone": "Telefonas",
  "formShipmentId": "Siuntos ID",
  "formQuestion": "Jūsų klausimas",
  "formAccountNumber": "Sąskaitos numeris (verslo klientams)",
  "formAddress": "Adresas",
  "formPostcode": "Pašto indeksas",
  "formCity": "Miestas",
  "formCountry": "Šalis",
  "formSubmitButton": "Pradėti pokalbį",
  "formEmptyFieldError": "Neleidžiama būti tuščia.",
  "formPhoneNumberValidationError": "Netinkamas telefono numeris.",
  "formInputIsBiggerThan50": "Turi būti ne daugiau kaip 50 simbolių.",
  "formInputIsBiggerThan100": "Turi būti ne daugiau kaip 100 simbolių.",
  "formInputIsBiggerThan2000": "Turi būti ne daugiau kaip 2000 simbolių.",
  "widgetEventOnline": "DA pranešimas: Vartotojas vėl prisijungęs.",
  "widgetEventHidden": "DA pranešimas: Valdiklis paslėptas.",
  "widgetEventVisible": "DA pranešimas: Valdiklis yra matomas.",
  "widgetEventVisibleMinimized": "DA pranešimas: Valdiklis yra matomas, bet sumažintas.",
  "widgetEventMinimized": "DA pranešimas: Valdiklis yra sumažintas iki minimumo.",
  "widgetEventMaximized": "DA pranešimas: Valdiklis maksimaliai padidintas.",
  "widgetEventSessionExpired": "DA pranešimas: Valdiklio sesija baigėsi.",
  "widgetEventHangupHuman": "DA pranešimas: vartotojas baigia žmogaus perėmimo sesiją.",
  "widgetEventUserTyping": "DA pranešimas: vartotojas rašo.",
  "fileTooLarge": "Bandote pridėti per didelius failus.",
  "tooManyDiles": "Bandote pridėti per daug failų.",
  "fileInvalidType": "Bandote pridėti neteisingus failų tipus.",
  "attachmentsDropHere": "Nuvilkite čia norėdami įkelti arba",
  "attachmentsBrowse": "Naršyti failus",
  "attachmentsExtenstionQuantity": "pdf arba vaizdai (iki 10 failų)",
  "attachmentsSize": "iki 30 MB",
  "attachmentsFailedUploading": "Įkelti nepavyko",
  "attachmentsUploading": "Įkeliama ...",
  "minimizeExpandText": "Tiesioginis pokalbis su mumis dabar!",
  "popupWidgetNotificationMessage": "Gavote naują žinutę!",
  "tabWidgetNotificationMessage": "Nauja žinutė!",
  "datepickerSendButton": "Siųsti"
}
